import React from "react";

const Footer = () => {
  return (
    <footer className="footer mx-auto">
      <div
        className="container mt-4 mb-4"
        style={{
          textAlign: "center",
          fontSize: "15px",
          fontFamily: "archiaregular",
        }}
      >
        <span className="text-muted">
          Copyright © 2020 Covid-19-Tracker by Sidharth Atri
        </span>
      </div>
    </footer>
  );
};
export default Footer;
